<template>
  <div class="add-content-box">
    <el-dialog
      :title="title"
      :visible.sync="dialogVisible"
      width="550px"
      :before-close="handleClose"
      :close-on-click-modal="false"
    >
      <el-form ref="form" :model="params" :rules="rules" label-width="130px">
        <el-form-item label="任务标题:" prop="title">
          <el-input
            v-model="params.title"
            type="text"
            size="small"
            placeholder="请输入任务标题"
            style="width:300px"
          ></el-input>
        </el-form-item>
        <el-form-item label="任务描述:" prop="desc">
          <el-input
            v-model="params.desc"
            type="textarea"
            size="small"
            :autosize="{ minRows: 2, maxRows: 4 }"
            placeholder="请输入任务描述"
            style="width:300px"
          ></el-input>
        </el-form-item>
        <el-form-item label="任务图片:" prop="bgImg">
          <base-upload
            class="upload"
            :cover="params.img"
            :wSize="180"
            :hSize="90"
            :width="'180px'"
            :height="'90px'"
            @successCallback="handleAvatarSuccess"
          ></base-upload>
        </el-form-item>
        <el-form-item label="任务奖品:" prop="prices">
          <el-select
            v-model="params.prizes"
            size="small"
            placeholder="请选择任务奖励"
            style="width:300px"
            multiple
            filterable
          >
            <el-option
              v-for="item in prizeBox"
              :value="item.value"
              :label="item.label"
              :key="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="任务类型:" prop="type">
          <el-select
            v-model="params.type"
            size="small"
            placeholder="请选择任务类型"
            style="width:300px"
          >
            <el-option
              v-for="item in types"
              :value="item.value"
              :label="item.label"
              :key="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="达成条件:" prop="finishCondition">
          <el-input
            v-model="params.finishCondition"
            type="number"
            size="small"
            placeholder="请输入达成条件(连续签到多少天/活跃值)"
            style="width:300px"
          ></el-input>
        </el-form-item>
        <el-form-item label="跳转方式:" prop="hrefType">
          <el-select
            v-model.number="hrefType"
            size="small"
            placeholder="跳转方式"
          >
            <el-option
              v-for="item in hrefTypeList"
              :value="item.value"
              :label="item.label"
              :key="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="跳转链接:" prop="link">
          <el-input
            v-if="hrefType == 0"
            v-model="params.link"
            size="small"
            placeholder="请输入链接地址"
          ></el-input>
          <el-select
            v-model="params.link"
            size="small"
            placeholder="请选择跳转"
            style="width:300px"
            filterable
            v-else-if="hrefType == 1"
          >
            <el-option
              v-for="item in links"
              :value="item.value"
              :label="item.label"
              :key="item.value"
            ></el-option>
          </el-select>
          <!-- <el-input
            v-model="params.link"
            type="textarea"
            size="small"
            :autosize="{ minRows: 2, maxRows: 4 }"
            placeholder="请输入跳转链接"
            style="width:300px"
          ></el-input> -->
        </el-form-item>
        <el-form-item
          label="视频ID:"
          prop="title"
          v-if="params.link == 'yinseinner://movieDetails?id='"
        >
          <el-input
            v-model="videoId"
            type="text"
            size="small"
            placeholder="请输入视频ID"
            style="width:300px"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="UP主ID:"
          prop="title"
          v-if="params.link == 'yinseinner://personal?uid='"
        >
          <el-input
            v-model="upId"
            type="text"
            size="small"
            placeholder="请输入UP主ID"
            style="width:300px"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="帖子ID:"
          prop="title"
          v-if="params.link == 'yinseinner://postDetails?id='"
        >
          <el-input
            v-model="postId"
            type="text"
            size="small"
            placeholder="请输入帖子ID"
            style="width:300px"
          ></el-input>
        </el-form-item>
        <el-form-item label="是否启用:" prop="status">
          <el-select
            v-model="params.status"
            size="small"
            placeholder="请选择是否启用"
            style="width:300px"
          >
            <el-option
              v-for="item in statusType"
              :value="item.value"
              :label="item.label"
              :key="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleClose" size="small">取 消</el-button>
        <el-button
          type="primary"
          size="small"
          @click="submitForm('form')"
          :loading="flag"
          >确 认</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>
<script>
import API from "@/api";
export default {
  props: {
    prizeBox: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      title: "",
      flag: false,
      id: "",
      dialogVisible: false,
      statusType: [
        {
          label: "启用",
          value: true,
        },
        {
          label: "禁用",
          value: false,
        },
      ],
      types: [
        {
          label: " 购买vip",
          value: 0,
        },
        {
          label: "绑定手机号",
          value: 1,
        },
        {
          label: "登录",
          value: 2,
        },
        {
          label: "关注用户",
          value: 3,
        },
        {
          label: "购买金币",
          value: 4,
        },
        {
          label: "发布作品",
          value: 5,
        },
        {
          label: "充值",
          value: 6,
        },
        {
          label: "邀请用户",
          value: 7,
        },
        {
          label: "评论被点赞",
          value: 8,
        },
        {
          label: "购买视频",
          value: 9,
        },
        {
          label: "广告点击",
          value: 10,
        },
      ],
      links: [
        { label: "会员中心", value: "yinseinner://vip_page" },
        { label: "金币钱包", value: "yinseinner://wallet_page" },
        { label: "抽奖", value: "yinseinner:// new_year_lottery_page" },
        { label: "分享推广页面", value: "yinseinner://personal_card" },
        { label: "收益中心", value: "yinseinner://incomeCenter" },
        { label: "任务中心", value: "yinseinner://freeBenefits" },
        { label: "创作中心", value: "yinseinner://creationCenter" },
        { label: "在线客服页面", value: "yinseinner://customerService" },
        { label: "跳转视频详情", value: "yinseinner://movieDetails?id=" },
        { label: "跳转UP主详情", value: "yinseinner://personal?uid=" },
        { label: "帖子详情", value: "yinseinner://postDetails?id=" },
        { label: "赚钱", value: "yinseinner://universal_agent" },
        { label: "游戏预售界面", value: "yinseinner://gameAdvancePage" },
      ],
      prices: [],
      rules: {
        finishCondition: [
          {
            required: true,
            message: "请输入达成条件(连续签到多少天/活跃值)",
            trigger: "blur",
          },
        ],
        type: [
          { required: true, message: "请选择配置类型", trigger: "change" },
        ],
        prizes: [
          { required: true, message: "请选择奖品列表", trigger: "change" },
        ],
      },
      params: {
        finishCondition: "",
        type: "",
        title: undefined,
        desc: undefined,
        prizes: [],
        status: false,
        img: "",
        link: "",
      },
      videoId: "",
      upId: "",
      postId: "",
      hrefType: 0, //跳转类型
      hrefTypeList: [
        { label: "外部浏览器跳转", value: 0 },
        { label: "APP内部跳转", value: 1 },
      ],
    };
  },
  methods: {
    // 表单验证提交
    submitForm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.flag = true;
          if (this.title === "新增配置") {
            this.addContent();
            return;
          }
          if (this.title === "编辑配置") {
            this.editContent();
            return;
          }
        }
      });
    },
    // 新增内容
    addContent() {
      if (this.params.link == "yinseinner://postDetails?id=" && !this.postId) {
        this.flag = false;
        this.$message({
          type: "error",
          message: "请输入帖子ID",
        });
        return;
      }
      if (
        this.params.link == "yinseinner://movieDetails?id=" &&
        !this.videoId
      ) {
        this.flag = false;
        this.$message({
          type: "error",
          message: "请输入视频ID",
        });
        return;
      }
      if (this.params.link == "yinseinner://personal?uid=" && !this.upId) {
        this.flag = false;
        this.$message({
          type: "error",
          message: "请输入UP主ID",
        });
        return;
      }
      if (this.params.link == "yinseinner://postDetails?id=") {
        this.params.link = this.params.link + this.postId;
      }
      if (this.params.link == "yinseinner://movieDetails?id=") {
        this.params.link = this.params.link + this.videoId;
      }
      if (this.upId && this.params.link == "yinseinner://personal?uid=") {
        this.params.link = this.params.link + this.upId;
      }
      let params = Object.assign({}, this.params, {
        finishCondition: Number(this.params.finishCondition),
      });
      API.addOneActivity(params)
        .then((res) => {
          if (res.code === 200) {
            this.$message({
              message: "新增成功",
              type: "success",
            });
            this.$emit("handlerContent");
          } else {
            this.$message.error(res.msg || "新增失败");
          }
          this.handleClose();
          this.flag = false;
        })
        .catch(() => {
          this.handleClose();
          this.flag = false;
        });
    },
    // 修改内容
    editContent() {
      if (this.params.link == "yinseinner://postDetails?id=" && !this.postId) {
        this.flag = false;
        this.$message({
          type: "error",
          message: "请输入帖子ID",
        });
        return;
      }
      if (
        this.params.link == "yinseinner://movieDetails?id=" &&
        !this.videoId
      ) {
        this.flag = false;
        this.$message({
          type: "error",
          message: "请输入视频ID",
        });
        return;
      }
      if (this.params.link == "yinseinner://personal?uid=" && !this.upId) {
        this.flag = false;
        this.$message({
          type: "error",
          message: "请输入UP主ID",
        });
        return;
      }
      if (this.params.link == "yinseinner://postDetails?id=") {
        this.params.link = this.params.link + this.postId;
      }
      if (this.params.link == "yinseinner://movieDetails?id=") {
        this.params.link = this.params.link + this.videoId;
      }
      if (this.upId && this.params.link == "yinseinner://personal?uid=") {
        this.params.link = this.params.link + this.upId;
      }
      let params = Object.assign({}, this.params, {
        finishCondition: Number(this.params.finishCondition),
      });
      API.editOneActive(params)
        .then((res) => {
          if (res.code === 200) {
            this.$message({
              message: "修改成功",
              type: "success",
            });
            this.$emit("handlerContent");
          } else {
            this.$message.error(res.msg || "修改失败");
          }
          this.flag = false;
          this.handleClose();
        })
        .catch(() => {
          this.handleClose();
          this.flag = false;
        });
    },
    // 标签封面上传成功回掉
    handleAvatarSuccess(res) {
      this.params.img = res.data.coverImg;
    },
    // 关闭弹窗
    handleClose() {
      this.dialogVisible = false;
      this.$refs.form.resetFields();
      this.params = {
        finishCondition: "",
        type: "",
        prizes: "",
        desc: undefined,
        title: undefined,
        status: false,
      };
    },
    open(type, data) {
      this.dialogVisible = true;
      // console.log("type-----", type);
      // console.log("data-----", data);
      if (type === "edit") {
        this.params = Object.assign({}, data);
        // console.log(obj);
        if (this.params.link.indexOf("movieDetails") !== -1) {
          // this.form.link = "yinseinner://topic_page";
          const splitArr = this.params.link.split("=");

          // this.form.link = splitArr[0] + '=';
          let urlIndex = this.params.link.indexOf("?");
          this.videoId = this.getUrlParam(
            this.params.link.substring(urlIndex),
            "id"
          );
          this.params.link = splitArr[0] + "=";
          // console.log(splitArr);
        } else if (this.params.link.indexOf("postDetails") !== -1) {
          const splitArr = this.params.link.split("=");
          let urlIndex = this.params.link.indexOf("?");
          this.postId = this.getUrlParam(
            this.params.link.substring(urlIndex),
            "id"
          );
          this.params.link = splitArr[0] + "=";
        } else if (this.params.link.indexOf("personal") !== -1) {
          const splitArr = this.params.link.split("?");
          let urlIndex = this.params.link.indexOf("?");
          this.upId = this.getUrlParam(
            this.params.link.substring(urlIndex),
            "uid"
          );
          this.params.link = splitArr[0];
        } else {
          this.params.link = this.params.link;
        }
        // console.log(this.params)
        this.params = Object.assign({}, this.params);
        this.title = "编辑配置";
      } else {
        this.title = "新增配置";
      }
    },
    getUrlParam(url, name) {
      var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)"); //构造一个含有目标参数的正则表达式对象
      var r = url.substr(1).match(reg); //匹配目标参数
      if (r != null) return unescape(r[2]);
      return null; //返回参数值
    },
  },
};
</script>
<style scoped>
.el-input {
  width: 220px;
}
</style>
